<template>
  <router-link :to="getTo()">
    <slot />
  </router-link>
</template>
<script>
import Cookie from 'vue-cookie'

export default {
  props: ["to"],
  methods: {
    getTo() {
			const locale = Cookie.get('locale');
      // we strip leading and trailing slashes and prefix
      // the current locale
      return `/${locale}/${this.to.replace(/^\/|\/$/g, "")}`
    }
  }
}
</script>
